<template>
  <!--TODO implement spinner on is Loading-->
  <div class="flex flex-col justify-items-center bg-white rounded shadow-xl py-1">
    <filter-menu-item v-for="(item, i) in filterMenuItems"
                      :key="i"
                      :label="item.label"
                      :is-selected="isSelected(item.type)"
                      :type="item.type"
                      :values="filterValues"
                      :use-logical-bots="useLogicalBots"
                      :class="`test-filter-menu-${item.type}`"
                      @click="selectItem(item.type)"
                      @change="$emit('filter-change', $event)"
    />

    <div class="flex flex-col justify-center p-4 mt-2">
      <t-button variant="primary" class="test-filter-results" @click="handleSubmitFilters">Filter Results</t-button>
      <t-button variant="transparent" class="mt-3" @click="$emit('reset-filters')">Reset Filters</t-button>
    </div>
  </div>
</template>

<script>
import ChartLegend from '@/components/analytics/charts/ChartLegend.vue'
import FilterMenuItem from './FilterMenuItem'

import { FILTER_ITEMS } from '@/utils/filter.constants'
import { getMarketsForLogicalBots, getLogicalBotId } from '@/utils/market.utils'

export default {
  name: 'FilterMenuDropdown',
  components: { ChartLegend, FilterMenuItem },

  props: {
    selectedItem: {
      type: String
    },
    showRequestOutcomes: {
      type: Boolean,
      default: false
    },
    showAssistanceResolutions: {
      type: Boolean,
      default: false
    },
    showChannels: {
      type: Boolean,
      default: false
    },
    showMarkets: {
      type: Boolean,
      default: false
    },
    showGranularity: {
      type: Boolean,
      default: false
    },
    showAnswer: {
      type: Boolean,
      default: false
    },
    useLogicalBots: {
      type: Boolean,
      default: false
    },
    filterValues: {
      type: Object
    }
  },

  computed: {
    hasMarketOptions() {
      const anchorLogicalBotId = getLogicalBotId(this.filterValues[FILTER_ITEMS.BOT])
      const selectedBots = this.filterValues[FILTER_ITEMS.BOTS] || (anchorLogicalBotId ? [anchorLogicalBotId] : [])
      return getMarketsForLogicalBots(selectedBots).length > 0
    },

    filterMenuItems() {
      const items = [
        {
          type: FILTER_ITEMS.BOT,
          label: this.useLogicalBots ? 'Virtual Assistants:' : 'Virtual Assistant:'
        },
        {
          type: FILTER_ITEMS.DATE_FROM,
          label: 'Date from:'
        },
        {
          type: FILTER_ITEMS.DATE_TO,
          label: 'Date to:'
        }
      ]

      if(this.showMarkets && this.hasMarketOptions) {
        items.splice(1, 0, {
          type: FILTER_ITEMS.MARKETS,
          label: 'Markets:'
        })
      }

      if(this.showGranularity) {
        items.push({
          type: FILTER_ITEMS.GRANULARITY,
          label: 'Granularity:'
        })
      }

      if(this.showRequestOutcomes) {
        items.push({
          type: FILTER_ITEMS.REQUEST_OUTCOME,
          label: 'Request Outcome:'
        })
      }

      if(this.showAssistanceResolutions) {
        items.push({
          type: FILTER_ITEMS.ASSISTANCE_RESOLUTIONS,
          label: 'Assistance Resolution:'
        })
      }

      if(this.showChannels) {
        items.push({
          type: FILTER_ITEMS.CHANNELS,
          label: 'Channels:'
        })
      }

      if(this.showAnswer) {
        items.push({
          type: FILTER_ITEMS.ANSWER_ID,
          label: 'Answer:'
        })
      }

      return items
    }
  },

  methods: {
    isSelected(type) {
      return type === this.selectedItem
    },

    handleSubmitFilters() {
      this.$emit('submit-filters')
    },

    selectItem(type) {
      this.$emit('select-item', type)
    }
  }
}
</script>
